import {
    Form,
    Input,
    Select,
    Radio,
    DatePicker,
    Checkbox,
    Button,
    notification,
    Spin,
    message,
    Modal,
} from "antd";
import React, { useEffect, useState } from 'react'
import { getAllGroup } from "../../../api/CommonRequest";
import moment from 'moment';
import ErrorLogout from "../../../helpers/ErrorLogout";

function BidScheduleModal({ approveModal, handleCancel, onFinishApproval, status }) {

    const [loader, setLoader] = useState(false);
    const [bidStartDate, setBidStartDate] = useState(Date.now())
    const [bidScheduleStatus, setBidScheduleStatus] = useState('now');
    const [groupBid, setGroupBid] = useState(false);
    const [loaderGroup, setLoaderGroup] = useState(false);
    const [groupList, setGroupList] = useState([]);

    const [form1] = Form.useForm();

    useEffect(() => {
        if (bidScheduleStatus === 'now') {
            setBidStartDate(moment()); // Set to current date
            form1.setFieldsValue({ startDate: moment() }); // Reset the start date in the form
        } else if (bidScheduleStatus === 'scheduleBid') {
            setBidStartDate(null); // Clear the start date for scheduling
            form1.setFieldsValue({ startDate: null });
        }
    }, [bidScheduleStatus, form1]);

    const onChangeGroupBid = (e) => {
        setGroupBid(e.target.value);

        groupCall()


    };

    const handleBidType = (e) => {
        setBidScheduleStatus(e.target.value);
    };


    const groupCall = async () => {
        try {
            setLoaderGroup(true)
            const { data } = await getAllGroup()
            if (data?.success) {
                setGroupList(data.groupList)
                setLoaderGroup(false)
            }
        } catch (error) {
            setLoaderGroup(false)
            console.log(error);
            console.log(error.message);
            if (error?.response?.status === 401) {
                ErrorLogout(error);
            }
        }
    };
    return (
        <div>
            <Modal
                open={approveModal}
                onCancel={handleCancel}
                footer={null}
                title={status === 'approved' ? "Bid Schedule" : "Bid Approval"}
            >
                <div className="p-4">
                    <Form
                        name="Bid Approval"
                        form={form1}
                        initialValues={{ remember: true,type:false }}
                        onFinish={onFinishApproval}
                    >
                        {/* Bid Type */}
                        <Form.Item name="bidType">
                            <Radio.Group
                                onChange={handleBidType}
                                defaultValue={bidScheduleStatus}
                                value={bidScheduleStatus}
                            >
                                <Radio value="now">Bid Now</Radio>
                                <Radio value="scheduleBid">Schedule Bid</Radio>
                                {status !== 'approved' && <Radio value="scheduleLater">Schedule Later</Radio>}
                                {/* <Radio value="scheduleLater">Schedule Later</Radio> */}
                            </Radio.Group>
                        </Form.Item>


                        {/* Only show DatePickers if not 'scheduleLater' */}
                        {bidScheduleStatus !== 'scheduleLater' && (
                            <>
                                {/* Bid Start Date */}
                                <Form.Item
                                    label="Start Date"
                                    name="startDate"
                                    rules={[
                                        { required: true, message: 'Please select the start date.' },
                                    ]}
                                >
                                    <DatePicker
                                        value={bidStartDate}
                                        // defaultValue={moment()}
                                        // onChange={(date) => setBidStartDate(date)}
                                        showTime
                                        placeholder="Select start date"
                                        className="w-full"
                                        dropdownStyle={{ maxHeight: '200px', overflowY: 'auto' }} // Adjust as needed

                                    />
                                </Form.Item>


                                {/* Bid End Date */}
                                <Form.Item
                                    label="Close Date"
                                    name="endDate"
                                    rules={[
                                        { required: true, message: 'Please select the close date.' },
                                    ]}
                                >
                                    <DatePicker
                                        // value={bidEndDate}
                                        // onChange={(date) => setBidEndDate(date)}
                                        showTime
                                        placeholder="Select close date"
                                        className="w-full"
                                        dropdownStyle={{ maxHeight: '200px', overflowY: 'auto' }} // Adjust as needed

                                    />
                                </Form.Item>
                            </>
                        )}


                        {status !== 'approved' &&
                            <>
                                {/* Initial Price */}
                                <Form.Item
                                    label="Initial Price"
                                    name="initialPrice"
                                    rules={[
                                        { required: true, message: 'Please enter the initial price.' },
                                    ]}
                                >
                                    <Input
                                        type="number"
                                        placeholder="Enter bid initial price"
                                        className="border-[#A3BBFF] border text-[#4A4A4C] text-base font-normal"
                                    />
                                </Form.Item>

                                 {/* Security Deposit */}
                                 <Form.Item
                                    label="Security Amount"
                                    name="securityAmount"
                                    rules={[
                                        { required: true, message: 'Please enter the Security Deposit.' },
                                    ]}
                                >
                                    <Input
                                        type="number"
                                        placeholder="Enter bid Security Deposit"
                                        className="border-[#A3BBFF] border text-[#4A4A4C] text-base font-normal"
                                    />
                                </Form.Item>

                                 {/* Min Bid Amount */}
                                 <Form.Item
                                    label="Min Bid Amount"
                                    name="minBidAmount"
                                    rules={[
                                        { required: true, message: 'Please enter the Min Bid Amount.' },
                                    ]}
                                >
                                    <Input
                                        type="number"
                                        placeholder="Enter bid Min Bid Amount"
                                        className="border-[#A3BBFF] border text-[#4A4A4C] text-base font-normal"
                                    />
                                </Form.Item>

                                {/* Group Bid or Public */}
                                <Form.Item
                                    
                                    name="type"
                                   
                                >
                                <Radio.Group
                               
                                    onChange={onChangeGroupBid}
                                    value={groupBid}
                                >
                                    <Radio  value={false}>Public</Radio>
                                    <Radio  value={true}>Group Bid</Radio>
                                </Radio.Group>
                                </Form.Item>

                                {/* Group Bid Dropdown */}
                                {groupBid && (
                                    <Form.Item
                                        name="groupID"
                                        className="mt-3"
                                        rules={[
                                            { required: true, message: 'Please select the number of seats.' },
                                        ]}
                                    >
                                        <Select
                                            // onChange={handleSelectChange}
                                            className="border-[#A3BBFF] h-10 border text-[#4A4A4C] text-base font-normal rounded-md"
                                            placeholder="Select an option"
                                            loading={loaderGroup}
                                        >
                                            {groupList.map((val) => (
                                                <Select.Option key={val._id} value={val._id} >
                                                    {val.name}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                )}
                            </>
                        }


                        {/* Submit and Cancel Buttons */}
                        <div className="flex justify-end mt-3">
                            <Button onClick={handleCancel} className="py-3 px-6 mr-4 font-semibold">
                                Dismiss
                            </Button>
                            <Button htmlType="submit" loading={loader} className="bg-blue-500 py-3 px-6 text-white font-medium">
                                Submit
                            </Button>
                        </div>
                    </Form>
                </div>
            </Modal >
        </div >
    )
}

export default BidScheduleModal